<template>
  <div>
    <h1 class="has-text-weight-bold leuris-heading">
      leuris:Forschungsbericht
    </h1>

    <div class="columns section" style="max-width: 1200px; margin: auto; padding-top: 0;">
      <div class="section has-text-centered" style="max-width: 1200px; width: 100%; padding-top: 0; margin: auto;">
        <div class="has-text-centered" style="max-width: 600px; margin: auto;">
          <translate>Login Description</translate>
        </div>
      </div>
    </div>
    <!--
    -->
    <div class="columns section" style="max-width: 1200px; margin: auto; margin-top: -50px;">
      <div class="column">
        <div>
          <b-message
            type="is-aquamarine"
            :title="$gettext('Login Systemrequirements Heading')"
            :closable="false"
          >
            <div v-html="$gettext('Login Systemrequirements Text')"></div>
          </b-message>
        </div>
      </div>
      <div class="column">
        <b-message
          type="is-lightgray"
          :title="$gettext('Login Not Working Heading')"
          :closable="false"
        >
          <div v-html="$gettext('Login Not Working Text')"></div>
        </b-message>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ToastError } from '@/utils'
import DynamicTitle from '@/components/mixins/DynamicTitle'

export default {
  name: 'fob-login',
  mixins: [DynamicTitle],
  data () {
    return {
      username: null,
      password: null,
      leurisHead: {
        inner: 'leuris:Forschungsbericht',
        complement: 'menu.login'
      }
    }
  },
  computed: {
    ...mapGetters({
      userIsAuthorized: 'user/isAuthorized'
    })
  },
  methods: {
    getUsername () {
      // transform username
      //   - to lower case
      //   - extract username from e-mail
      // needed to avoid login failures
      return this.username
        .toLowerCase()
        .split('@')[0]
    },
    login () {
      this.$store.dispatch('user/login',
        {
          username: this.getUsername(),
          password: this.password
        }
      )
        .then(() => { this.$router.push({ name: 'start' }) })
        .catch(() => {
          ToastError(this.$gettext(`toast.login.failed`))
          this.$store.dispatch('resetLoading')
        })
    }
  }
}
</script>

<style>
  .leuris-heading {
	font-family: 'Futura', 'Nunito Sans', 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 34px;
    text-transform: uppercase;
    max-width: 1200px;
    margin: auto;
    margin-top: 50px;
    margin-bottom: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 30px;
  }

  .leuris-heading::before, .leuris-heading::after {
    flex-grow: 1;
    content: '';
    height: 1px;
    border-top: 2px solid;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue